/**
 * Copyright (c) Microsoft. All rights reserved.
 */
import { observer } from 'mobx-react';
import * as React from 'react';
import { TooltipRenderer } from '../../../components/svgRenderers/utilities/TooltipRenderer';
import { onAnnotationKeyDown } from '../../../utils/annotationUtils';
import { annotationDataAttribute, annotationEndLineIndexDataAttribute, annotationEndTokenIndexDataAttribute, annotationIndexDataAttribute, annotationStartLineIndexDataAttribute, annotationStartTokenIndexDataAttribute } from '../../../utils/labelerConstants';
import { useLabelerStore } from '../../../utils/labelerStoreContext';
export const BaseShapeSvgRenderer = observer((props) => {
    const { annotationKey, startToken, startLine, endToken, endLine, children, onClick, opacity = 1, isClickable, onRenderTooltip } = props;
    const { a11yStore, configStore } = useLabelerStore();
    const [toolTipData, setTooltipData] = React.useState(null);
    const cursorType = isClickable && configStore.areAnnotationsClickable ? 'pointer' : 'default';
    const annotationDataAttributes = {
        [annotationDataAttribute]: true,
        [annotationIndexDataAttribute]: annotationKey,
        [annotationEndLineIndexDataAttribute]: endLine,
        [annotationEndTokenIndexDataAttribute]: endToken,
        [annotationStartLineIndexDataAttribute]: startLine,
        [annotationStartTokenIndexDataAttribute]: startToken
    };
    const handleAnnotationClick = React.useCallback((event) => {
        handleAnnotationUnHover();
        if (isClickable && configStore.areAnnotationsClickable) {
            onClick(event);
        }
    }, [onClick]);
    const handleAnnotationHover = React.useCallback((event) => {
        setTooltipData({ isVisible: true, x: event.clientX, y: event.clientY });
    }, []);
    const handleAnnotationUnHover = React.useCallback(() => {
        setTooltipData(Object.assign(Object.assign({}, toolTipData), { isVisible: false }));
    }, []);
    return (React.createElement("g", Object.assign({ style: { opacity }, cursor: cursorType }, annotationDataAttributes, { onClick: handleAnnotationClick, onMouseOver: handleAnnotationHover, onMouseLeave: handleAnnotationUnHover, onKeyDown: event => onAnnotationKeyDown({ event, a11yStore }) }),
        children,
        (toolTipData === null || toolTipData === void 0 ? void 0 : toolTipData.isVisible) && onRenderTooltip && (React.createElement(TooltipRenderer, { onRenderTooltip: onRenderTooltip, x: toolTipData.x, y: toolTipData.y }))));
});
